import React from 'react';

import MenuItem from '~/components/core/Atomic/MenuItem';
import SingleSelectField from '~/components/core/Molecules/Fields/SingleSelectField';
import SimpleSearchField from '~/components/core/SimpleSearchField';
import { LobMultiSelect } from '~/components/TPA/LOB/LobMultiselect';
import SubOrganizationMultiSelect from '~/components/TPA/SubOrganizations/SubOrganizationMultiSelect';

import type { GuardrailOutcomeFilter, SysconfigOrganization } from '../types';

interface GuardrailRulesFiltersProps {
  organization: SysconfigOrganization;
  subOrgIds: number[];
  outcome: GuardrailOutcomeFilter;
  onSearchTermChanged: (searchTerm: string) => void;
  onSubOrgChanged: (subOrgIds: number[]) => void;
  onLobsChanged: (lobs: string[]) => void;
  onOutcomeChanged: (outcome: GuardrailOutcomeFilter) => void;
}

export const GuardrailRulesFilters: React.FC<GuardrailRulesFiltersProps> = ({
  organization,
  subOrgIds,
  outcome,
  onSearchTermChanged,
  onSubOrgChanged,
  onLobsChanged,
  onOutcomeChanged,
}) => (
  <div className="grid grid-cols-4 items-baseline gap-4 pb-40">
    <SimpleSearchField label="Search Guardrail" placeholder="Search" onChange={onSearchTermChanged} />
    {organization.sub_organizations_enabled && <SubOrganizationMultiSelect onChange={onSubOrgChanged} />}
    {/* LobMultiSelect is an untyped JS component; its `subOrganizationIds`
        PropTypes.array infers as `never[]`, so `number[]` needs this assertion
        (same as the WorkflowEngine sibling). */}
    <LobMultiSelect subOrganizationIds={subOrgIds as never[]} onChange={onLobsChanged} />
    <SingleSelectField<GuardrailOutcomeFilter>
      label="Type"
      fullWidth
      autoSelectSingleOption={false}
      value={outcome}
      onChange={(value) => onOutcomeChanged(value)}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="warn">Warning</MenuItem>
      <MenuItem value="block">Block</MenuItem>
      <MenuItem value="route_to_human">Route to Human</MenuItem>
    </SingleSelectField>
  </div>
);

export default GuardrailRulesFilters;
